export const getUsAvatarSrc = (): string => {
  return 'https://assets.urbansitter.com/static/img/logos/urbansitter-white-avatar.svg';
};
